var ApplyBoxFixer = function(domElement) {
    this.domElement = domElement;
    this.isFixed = false;
    this.scrollDownTrigger = domElement.parentElement.offsetTop;
    this.scrollUpTrigger = domElement.parentElement.offsetTop - 20;

    this.onScroll = function() {
        var scrollAmount = (window.pageYOffset !== undefined) ? window.pageYOffset : window.scrollY; // IE Compat

        if (scrollAmount > this.scrollDownTrigger && !this.isFixed) {
            this.isFixed = true;
            this.domElement.classList.add('fixed');
        } if (scrollAmount <= this.scrollUpTrigger && this.isFixed) {
            this.isFixed = false;
            this.domElement.classList.remove('fixed');
        }
    }
    window.addEventListener('scroll', this.onScroll.bind(this));
}

if (document.querySelector('.apply-box')) {
    var applyBoxFixer = new ApplyBoxFixer(document.querySelector('.apply-box'));
}